import { render, staticRenderFns } from "./CustomBtn.vue?vue&type=template&id=6ecf2534"
import script from "./CustomBtn.vue?vue&type=script&lang=js"
export * from "./CustomBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports